import React from 'react'
import { AmbassadorSection } from '../../../../../../Components/City/Page/Ambassador/AmbassadorSection'
import ConnectedBankDetailsSection from '../../View/BankDetailsSection'

const BankDetailsSection = ({ ambassador }) => {
  return (
    <AmbassadorSection>
      <ConnectedBankDetailsSection
        ambassadorId={ambassador.id}
        paymentDetails={ambassador.paymentDetails}
        withholdPay={ambassador.withholdPay}
        fixedPriceMissions={ambassador.fixedPriceMissions}
      />
    </AmbassadorSection>
  )
}

export default BankDetailsSection



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Ambasador/Components/BankDetailsSection/index.js